import alert from '@/plugins/alert'
import { TeachingPlan, TeachingPlanConfig } from '@/plugins/api'
import { rangeRight } from 'lodash'

export default {
  namespaced: true,
  state: {
    loading: false,
    teachingPlanData: {},
    count: 0,
    search: [],
    pageText: '',
    itemsPerPage: 10,
    teachingPlanSearchParams: {},
    totalItems: 0,
    teachingPlanes: [],
    teachingPlanConfig: {},
    item: {},
  },
  actions: {
    async fetchTeachingPlanConfig({ commit }) {
      commit('changeState', { loading: true })
      try {
        const response = await TeachingPlanConfig.search({})
        commit('changeState', { teachingPlanConfig: response })
      } catch (error) {
        console.error('Lỗi khi lấy cấu hình khai kế hoạch giảng dạy :', error)
      } finally {
        commit('changeState', { loading: false })
      }
    },
    async toggleRegistrationStatus({ dispatch, state }) {
      try {
        const currentStatus = state.teachingPlanConfig.isOpen
        await TeachingPlanConfig.create({ isOpen: !currentStatus })
        await dispatch('fetchTeachingPlanConfig')
      } catch (error) {
        console.error('Lỗi khi cập nhật trạng thái khai:', error)
      }
    },
    async searchTeachingPlanList({ commit, state, dispatch }, query) {
      const teachingPlanSearchParams = {
        isDelete: false,
        _limit: state.itemsPerPage,
        ...query,
      }
      commit('changeState', { teachingPlanSearchParams })
      dispatch('requestPageSettings', {})
    },
    async getTeachingPlanForCopy({ commit, state, dispatch }, query) {
      const param = {
        isDelete: false,
        _limit: state.itemsPerPage,
        ...query,
      }
      return TeachingPlan.search(param)
    },
    async getListTeachingPlanClassNote({ commit, state, dispatch }, query) {
      const param = {
        isDelete: false,
        _limit: state.itemsPerPage,
        ...query,
      }
      return TeachingPlan.getTeachingPlanForClassNote(param)
    },
    async fetchOneForCopy({ commit }, id) {
      const item = await TeachingPlan.fetchOne(id)
      return item
    },
    async requestPageSettings({ state, commit, dispatch }, { page, itemsPerPage }) {
      commit('changeState', { loading: true })
      if (!page) page = 1
      if (!itemsPerPage) itemsPerPage = state.itemsPerPage
      if (state.teachingPlanSearchParams) {
        const teachingPlanSearchParams = {
          ...state.teachingPlanSearchParams,
          isDelete: false,
          _start: (page - 1) * itemsPerPage,
          _limit: itemsPerPage,
          _sort: 'tags:ASC',
        }
        let totalItemsPromise
        if (teachingPlanSearchParams.isReport !== true) {
          totalItemsPromise = TeachingPlan.count(teachingPlanSearchParams)
        }
        const [totalItems, teachingPlanes] = await Promise.all([
          totalItemsPromise,
          TeachingPlan.search(teachingPlanSearchParams),
        ])
        if (totalItems > (page - 1) * itemsPerPage || page === 1) {
          commit('changeState', {
            teachingPlanes,
            totalItems,
            itemsPerPage,
            teachingPlanSearchParams,
          })
          const pageStart = (page - 1) * itemsPerPage + 1
          let pageStop = page * itemsPerPage
          pageStop = pageStop > totalItems || pageStop === -1 ? totalItems : pageStop
          const pageText = `${pageStart}-${pageStop} trên ${totalItems}`
          commit('setPageText', pageText)
        } else {
          var pages = rangeRight(1, page)
          for (let index = 0; index < pages; index++) {
            const selectedPage = pages[index]
            if (totalItems > (selectedPage - 1) * itemsPerPage) {
              dispatch('requestPageSettings', {})
              break
            }
          }
        }
      }
      commit('changeState', { loading: false })
    },
    async createTeachingPlan({ commit, state }, teachingPlanData) {
      try {
        console.log(teachingPlanData)
        const created = await TeachingPlan.create(teachingPlanData)
        commit('changeState', {
          teachingPlanes: [created, ...state.teachingPlanes],
        })
        return created
      } catch (e) {
        alert.error(e)
      }
    },
    async updateTeachingPlan({ commit, state }, { id, ...teachingPlanData }) {
      const updated = await TeachingPlan.update(id, teachingPlanData)
      commit('updateTeachingPlan', updated)
      return updated
    },
    async removeTeachingPlan({ commit }, id) {
      await TeachingPlan.remove(id)
      commit('removeTeachingPlan', id)
    },
    setTeachingPlan({ commit }, teachingPlanData) {
      commit('setTeachingPlan', teachingPlanData)
    },
    async fetchOne({ commit }, id) {
      const item = await TeachingPlan.fetchOne(id)
      commit('changeState', { item })
    },
  },
  mutations: {
    setPageText(state, pageText) {
      state.pageText = pageText
    },
    updateTeachingPlan(state, teachingPlanData) {
      state.teachingPlanes = state.teachingPlanes.map(c => (teachingPlanData._id === c._id ? teachingPlanData : c))
    },
    removeTeachingPlan(state, id) {
      state.teachingPlanes = state.teachingPlanes.filter(d => d._id !== id)
    },
    changeState(state, payload) {
      Object.assign(state, payload)
    },
  },
  getters: {
    item: state => state.item,
  },
}
